import {
  SaleVehicleAlbumPhotoResponseBody,
  SaleVehiclePromoPhotoResponseBody,
} from '@dms/api/vehicle';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

export const toUnifiedAlbumImage = (
  image: SaleVehicleAlbumPhotoResponseBody | SaleVehiclePromoPhotoResponseBody
): UnifiedAlbumImage => {
  if ('position' in image) {
    return {
      ...image,
      url: image.url?.replace('/get/', '/resize/') ?? image.url,
      latestFileOperation: null,
      weight: image.position,
      isCoverPhoto: false,
      isPromoPhoto: false,
      position: image.position,
      positionInSettings: image.positionInSettings,
    };
  }
  return {
    ...image,
    url: image.url?.replace('/get/', '/resize/') ?? image.url,
    isPromoPhoto: false,
  };
};
